import { useEffect } from 'react';

const USERWAY_SCRIPT_SRC = 'https://cdn.userway.org/widget.js';

const UserWay = () => {
  useEffect(() => {
    if (window.Cypress) return; // disable for cypress tests

    // Check if the script is already present
    const alreadyExists = !!document.querySelector(
      `script[src="${USERWAY_SCRIPT_SRC}"]`,
    );
    if (alreadyExists) return;

    var s = document.createElement('script');
    /* uncomment the following line to override default position*/
    s.setAttribute('data-position', 5);
    /* uncomment the following line to override default size (values: small, large)*/
    /* s.setAttribute("data-size", "small");*/
    /* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
    /* s.setAttribute("data-language", "language");*/
    /* uncomment the following line to override color set via widget (e.g., #053f67)*/
    /* s.setAttribute("data-color", "#053e67");*/
    /* uncomment the following line to override type set via widget (1=person, 2=chair, 3=eye, 4=text)*/
    /* s.setAttribute("data-type", "1");*/
    /* s.setAttribute("data-statement_text:", "Our Accessibility Statement");*/
    /* s.setAttribute("data-statement_url", "http://www.example.com/accessibility")";*/
    /* uncomment the following line to override support on mobile devices*/
    /* s.setAttribute("data-mobile", true);*/
    /* uncomment the following line to set custom trigger action for accessibility menu*/
    /* s.setAttribute("data-trigger", "triggerId")*/
    /* uncomment the following line to override widget's z-index property*/
    /* s.setAttribute("data-z-index", 10001);*/
    /* uncomment the following line to enable Live site translations (e.g., fr, de, es, he, nl, etc.)*/
    /* s.setAttribute("data-site-language", "null");*/
    s.setAttribute('data-widget_layout', 'full');
    s.setAttribute('data-account', 'jxpmaaG5wA');
    s.setAttribute('src', USERWAY_SCRIPT_SRC);
    /* istanbul ignore next */
    (document.body || document.head).appendChild(s);
  }, []);

  // Render a testable marker for Testing Library
  return (
    <div data-testid="userway-script-loader" style={{ display: 'none' }} />
  );
};
export default UserWay;
